<template>
    <Modal :show="showCashoutModal" @close="showCashoutModal = false" :closeable="true" maxWidth="'4xl'">
        <div class="bg-blu-900 text-center  rounded p-4">
            <p class="font-bold">Cash Out</p>
            <div class="text-[12px] my-1 min-h-[30px] flex items-center justify-center">
                <div v-if="isLoadingCashout" class="spinner mr-2" />
                <span v-else class="text-[var(--color-primary1)] font-bold text-base">
                    {{ toFixedTwo(value) }}
                </span>
            </div>
            <div class="flex items-center gap-2 justify-center mt-6">
                <DefaultButton class="bg-neutral-600/75 text-white" @click="reject">{{ $t('terms.modal.reject') }}</DefaultButton>
                <DefaultButton @click="accept">{{ $t('terms.modal.accept') }}</DefaultButton>
            </div>
        </div>
    </Modal>
  </template>
  
  <script setup>
  import { ref } from 'vue';
  import Modal from '@/components/Modal.vue';
  import DefaultButton from '@/components/Buttons/DefaultButton.vue';
  import Spinner from '@/components/Spinner.vue';
  import { toFixedTwo } from '@/helpers';

const props = defineProps({
    value: String | Number,
    isLoadingCashout: Boolean
})

  const showCashoutModal = ref(false);
  const emit = defineEmits(['accept']);

  const reject = ()=>{
    showCashoutModal.value = false
  }
  const accept = async () => {
    emit('accept');
    showCashoutModal.value = false;
  }
  defineExpose({
    openModal: () => {
        showCashoutModal.value = true;
    }
  });
  </script>
  <style scoped>
.spinner,
.spinner:after {
    border-radius: 50%;
    width: 1.5em;
    height: 1.5em;
}

.spinner {
    font-size: 10px;
    position: relative;
    text-indent: -9999em;
    border-top: 0.2em solid var(--color-grey4);
    border-right: 0.2em solid var(--color-grey4);
    border-bottom: 0.2em solid var(--color-grey4);
    border-left: 0.2em solid transparent;
    transform: translateZ(0);
    animation: spinning 1s infinite linear;
}

@keyframes spinning {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
